(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('phoneFormatter', function () {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function (scope, element, attrs, ngModel) {
					element.bind('keyup change', function () {
						scope.$apply(formatPhone);
					});

					function formatPhone() {
						var value = ngModel.$viewValue;
						if (value != null && value != undefined) {
							value = value.replace(/[^0-9]/g, '');
							if (value.length >= 4 && scope.lang === 'en' && value.substring(3, 4) != '-') {
								value = value.substring(0, 3) + "-" + value.substring(3, value.length);
							}

							if (value.length >= 4 && scope.lang === 'fr' && value.substring(3, 4) != ' ') {
								value = value.substring(0, 3) + " " + value.substring(3, value.length);
							}

							if (value.length >= 8 && value.substring(7, 8) != '-') {
								value = value.substring(0, 7) + "-" + value.substring(7, value.length);
							}

							//ngModel.$setViewValue(value);
							ngModel.$viewValue = value;
							ngModel.modelValue = value.replace(/\D/g, '').replace(/(\d{3})(\d{7})/, "$1-$2");
							scope.ngModel = value.replace(/\D/g, '').replace(/(\d{3})(\d{7})/, "$1-$2");
							ngModel.$render();
							ngModel.$commitViewValue();


							//prevent repeating same digits
							if (preventRepeat(value)) {
								ngModel.$setValidity('pattern', false);
							}
						}
					}

					function preventRepeat(value) {
						value = value.replace(/-/g, "");
						var patt = /(^0{10}|1{10}|2{10}|3{10}|4{10}|5{10}|6{10}|7{10}|8{10}|9{10})$/i
						if (patt.test(value)) {
							return true;
						}
						return false;
					}
				}
			}
		});

})();
